import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '@app/core/tokens/api-base-url.token';

export interface UserExistRequest {
  phoneNumber: string;
  serialNumber: string;
  fullName: string;
}

export interface AccrueBatchItem {
  userId: string;
  amount: number;
  certificateId: string | null;
}

export interface AccrueBatchRequest {
  comment: string;
  items: AccrueBatchItem[];
}

export interface CancelBatchItem {
  userId: string;
  amount: number;
  certificateId: string | null;
}

export interface CancelBatchRequest {
  comment: string;
  items: CancelBatchItem[];
}

@Injectable({
  providedIn: 'root',
})
export class AdminBonusService {
  private readonly http = inject(HttpClient);
  private readonly apiBaseUrl = inject(API_BASE_URL);

  private get baseUrl(): string {
    return `${this.apiBaseUrl}/admin/bonus`;
  }

  userExist(request: UserExistRequest): Observable<unknown> {
    const params = new HttpParams()
      .set('phoneNumber', request.phoneNumber ?? '')
      .set('serialNumber', request.serialNumber ?? '')
      .set('fullName', request.fullName ?? '');
    return this.http.get<unknown>(`${this.baseUrl}/user-exist`, { params });
  }

  accrueBatch(request: AccrueBatchRequest): Observable<unknown> {
    return this.http.post<unknown>(`${this.baseUrl}/accrue-batch`, request);
  }

  cancelBatch(request: CancelBatchRequest): Observable<unknown> {
    return this.http.post<unknown>(`${this.baseUrl}/cancel-batch`, request);
  }
}
